import "./reactive-element-BDpydG15.js";
import { query as y } from "../beacon-query.d/index.js";
import { queryAll as S } from "../beacon-query-all.d/index.js";
const f = ({
  finisher: e,
  descriptor: l
}) => (
  // eslint-disable-next-line consistent-return
  (t, u) => {
    var n;
    if (u !== void 0) {
      const a = t.constructor;
      l !== void 0 && Object.defineProperty(t, u, l(u)), e == null || e(a, u);
    } else {
      const a = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (n = t.originalKey) != null ? n : t.key
      ), r = l !== void 0 ? {
        kind: "method",
        placement: "prototype",
        key: a,
        descriptor: l(t.key)
      } : { ...t, key: a };
      return e && (r.finisher = function(i) {
        e(i, a);
      }), r;
    }
  }
);
function c(e, l, t = {}, u = !1) {
  var r;
  const n = `slot${l ? `[name=${l}]` : ":not([name])"}`, a = (r = e.renderRoot) == null ? void 0 : r.querySelector(n);
  return a ? u ? a.assignedNodes(t).filter((i) => i.nodeType !== Node.COMMENT_NODE) : a.assignedElements(t) : [];
}
function g(e) {
  return typeof e == "string" ? { version: e } : e.alternateSlot !== void 0 && e.alternateSlot !== null ? { alternateSlot: e.alternateSlot, version: e.version } : { alternateAttribute: e.alternateAttribute, version: e.version };
}
function h(e, l = !1) {
  const { slot: t, selector: u, deprecated: n, flatten: a } = e != null ? e : {};
  let r;
  return n && (r = g(n)), f({
    descriptor: (i) => ({
      get() {
        let o = c(this, t, { flatten: a });
        return o.length === 0 && n && r && r.alternateSlot && (o = c(this, r.alternateSlot, { flatten: a })), u ? o == null ? void 0 : o.filter((s) => {
          var m;
          return l ? ((m = s == null ? void 0 : s.nodeName) == null ? void 0 : m.toLowerCase()) === this.getScopedTagName(u) : s.matches(u);
        }) : o;
      },
      set(o) {
        if (n) {
          const s = t != null ? t : "";
          this.alternateSlots.set(s, r);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function N(e) {
  return function(l, t) {
    return y(e)(l, t);
  };
}
function q(e, l) {
  return f({
    descriptor: (t) => ({
      get() {
        var n;
        return (n = this.querySelector(e)) != null ? n : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function A(e) {
  return function(l, t) {
    return S(e)(l, t);
  };
}
function E(e, l = !1) {
  const { slot: t, selector: u, deprecated: n, flatten: a } = e != null ? e : {};
  let r;
  return n && (r = g(n)), f({
    descriptor: (i) => ({
      get() {
        let o = c(this, t, { flatten: a }, !0);
        return o.length === 0 && n && r && r.alternateSlot && (o = c(this, r.alternateSlot, { flatten: a }, !0)), o;
      },
      set(o) {
        if (n) {
          const s = t != null ? t : "";
          this.alternateSlots.set(s, r);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
export {
  N as a,
  E as b,
  h as c,
  A as d,
  q
};
